module.exports = __webpack_public_path__ + "static/media/ChairLeg_After.5ea7fab7.jpg";